
import { backendExceptionHandler } from "@/mixins";
import UserService from '@/service/UserService';

    export default {
        name: "IntroductionPortfolioTourModal",
        mixins: [ backendExceptionHandler ],
        props: {
            isVisible: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                isVisiableUserTour: false,
                loading: false,
                isLoadingAction: false,
                urlVideo: "https://www.youtube.com/embed/oaRyegDVq_A"
            }
        },

        computed: {
            getCurrencyUser() {
                return this.$store.state.account.currency;
            },
        },

        methods: {
            async closeWindow(isShowCreateModal) {
                this.$emit('update:is-visible', false)
                await this.updateStatusViewTourUser()
                if(isShowCreateModal) this.$emit('intro-portfolio-tour-close');
            },
            async updateStatusViewTourUser() {
                this.isLoadingAction = true;
                const showUserTour = false;
                try {
                    const data = {
                        currency: this.getCurrencyUser,
                        showNewUsersTour: showUserTour
                    };
                    await this.userService.updateViewTourUSer(data);
                    this.$store.commit('account/setShowNewUsersTour', showUserTour);
                    this.isLoadingAction = false;
                } catch(e) {
                    this.handleBackendException(e, 'Ein Fehler ist aufgetreten')
                } finally {
                    this.isLoadingAction = false;
                }
            }
        },

        created() {
            this.userService = new UserService(this.$axios)
        },

        beforeDestroy() {
            this.$emit('update:is-visible', false)
            this.$store.commit('account/setShowNewUsersTour', false);
        },

        watch: {
            isVisible: {
                immediate: true,
                handler(value) {
                    this.isVisiableUserTour = value;
                }
            },
            isVisiableUserTour(value) {
                if(value) return;
                const videoTour = this.$refs.videoTourElement;
                const srcVideo = videoTour.src;
                videoTour.src = `${srcVideo}` // reset value of src to pause video
            }
        }
    }
